<template>
    <div class="online-booking-flow-choices">
        <div class="big-radio-choice flex m-b-10 cursor-pointer" :class="{ 'selected' : !value || value === 'this' }" @click.prevent="$emit('input', 'this')">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
                <i class="zmdi zmdi-check-circle" v-if="!value || value === 'this'"></i>
                <i class="zmdi zmdi zmdi-circle-o" v-else></i>
            </div>

            <div class="big-radio-description">
                <b class="m-0 block">{{ trans('calendar.recurring_action_this_one') }}</b>
                <small class="text-muted">{{ trans(`calendar.recurring_action_this_one_${type}_desc`) }}</small>
            </div>
        </div>
        <div class="big-radio-choice flex m-b-10 cursor-pointer " :class="{ 'selected' : value === 'future' }" @click.prevent="$emit('input', 'future')">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
                <i class="zmdi zmdi-check-circle" v-if="value === 'future'"></i>
                <i class="zmdi zmdi zmdi-circle-o" v-else></i>
            </div>

            <div class="big-radio-description">
                <b class="m-0 block">{{ trans('calendar.recurring_action_future') }}</b>
                <small class="text-muted">{{ trans(`calendar.recurring_action_future_${type}_desc`, { count: future_bookings_count }) }}</small>
            </div>
        </div>
        <div class="big-radio-choice flex m-b-20 cursor-pointer " :class="{ 'selected' : value === 'all' }" @click.prevent="$emit('input', 'all')">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
                <i class="zmdi zmdi-check-circle" v-if="value === 'all'"></i>
                <i class="zmdi zmdi zmdi-circle-o" v-else></i>
            </div>

            <div class="big-radio-description">
                <b class="m-0 block">{{ trans('calendar.recurring_action_all') }}</b>
                <small class="text-muted">{{ trans(`calendar.recurring_action_all_${type}_desc`, { count: bookings_count }) }}</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecurringActionChoices',

    props: {
        booking: {
            required: true,
            type: Object,
        },

        type: {
            required: true,
            type: String,
        },

        value: {
            required: false,
            default: 'this',
        },
    },

    computed: {
        bookings_count() {
            return this.booking && this.booking.recurring_booking_group
                ? this.booking.recurring_booking_group.bookings_count - 1
                : '';
        },

        future_bookings_count() {
            return this.booking && this.booking.recurring_booking_group
                ? this.booking.recurring_booking_group.future_bookings_count
                : '';
        },
    }
}
</script>
